import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const LoadingState = ({ className, message = 'Loading cruise data...' }) => (
  <div className="w-full bg-transparent p-0 flex items-center justify-center">
    <div className={clsx(
      'relative mx-auto bg-white rounded-lg shadow-sm border p-6 text-center',
      className)}>
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
      <p className="text-gray-600">{message}</p>
    </div>
  </div>
);

LoadingState.propTypes = {
  /** Loading message to display */
  className: PropTypes.string,
  message: PropTypes.string
};

LoadingState.defaultProps = {
  message: 'Loading cruise data...'
};

export default LoadingState;